<template>
  <layout-with-sidebar>
    <HeaderComponent/>

    <div class="container ed-bg text-color" style="margin: 0px 6px 0px 10px; ">
      <div class="row">

        <div class="col-12 col-xs-12 ">

          <div class="modify-amortization">
            <div id="subLayout-container">


              <div class="module-title-toolbar">

                <div class="row"
                     style="background-color: #222939;  background-color: #0a1727; background-color: #2B2B2B; color: white; margin-top:6px; padding:4px 0px 4px 0px !important;">

                  <div class="col-11 col-xs-6 col-sm-11 col-md-10 col-lg-11" style="">

                    <div class="row">

                      <div class="col-12 col-sm-3 col-md-3 col-lg-3"
                           style="padding-bottom:0px;">
                        <div class="form-group input-group-sm "
                             style="padding-bottom:0px;  margin-bottom: 0px !important;">
                          <label style="display: inline; width:30%; margin-right:5px">
                            <small>Codice</small>
                          </label>
                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 style="display: inline;width:46%" type="text"
                                 class="form-control input-xs"
                                 v-model="amortization.code"
                                 aria-describedby="sizing-addon3">
                        </div>
                      </div>
                      <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                        <div class="form-group input-group-sm"
                             style="margin-bottom: 0px !important;">
                          <label style="display: inline;margin-right:4px">
                            <small> Descrizione</small>
                          </label>
                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 style="display: inline;width:65%"
                                 v-model="amortization.description"
                                 type="text" class="form-control input-xs"
                                 aria-describedby="sizing-addon3">
                        </div>
                      </div>
                      <div class="col-12 col-sm-4 col-md-4 col-lg-3">
                        <div class="form-group input-group-sm"
                             style="margin-bottom: 0px !important;">
                          <label style="display: inline;margin-right:4px">
                            <small> Data</small>
                          </label>
                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 style="display: inline;width:78%"
                                 v-model="amortization.practice_date" type="date"
                                 class="form-control input-xs"

                                 aria-describedby="sizing-addon3">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>

              <div id="cambiale" class="module" style="margin-top:5px;margin-bottom:5px;">


                <div class="module-title-toolbar">

                  <div class="row">
                    <div class="col-8 col-xs-6 col-sm-6 col-md-8 col-lg-8 text-left">
                      <h4 class="pull-left" v-if="amortization.name">Modifica Cambiale
                        {{ amortization.name }}</h4>
                      <h4 class="pull-left" v-if="!amortization.name">Nuova Cambiale
                      </h4>
                    </div>

                    <div class="col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4">

                    </div>
                  </div>

                </div>


                <div class="module-content">


                  <div class="row">

                    <div class="col-2 col-xs-12 col-sm-2 col-md-2 col-lg-2">
                      <img class="media-object" src="/images/cambialeLogo.png" alt="..."
                           width="140"
                           height="140">
                    </div>


                    <div class="col-10 col-xs-12 col-sm-10 col-md-10 col-lg-10">

                      <div class="row">
                        <div class="col-5 col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div class="form-group input-group-sm">
                            <label>
                              <small style="color: black;">Luogo emissione
                                cambiale
                              </small>
                            </label>
                            <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                   id="cambiale_luogoEmissione" type="text"
                                   class="form-control input-size-xs"
                                   placeholder="Luogo Emissione Cambiale"
                                   v-model="amortization.place_issue"
                                   aria-describedby="sizing-addon3">
                          </div>
                        </div>

                        <div
                            class="col-3 col-xs-12 col-sm-3 col-md-3 col-lg-3   col-xs-push-0 col-sm-push-0 col-md-push-0 col-lg-push-0 ">
                          <div class="form-group input-group-sm">
                            <label>
                              <small style="color: black;">Data emissione</small>
                            </label>
                            <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                   id="cambiale_dataEmissione" type="date"
                                   class="form-control input-size-xs"
                                   v-model="amortization.date_issue"
                                   placeholder="Data Emissione Cambiale">
                          </div>
                        </div>

                        <div
                            class="col-xs-12 col-sm-4 col-md-4 col-lg-4  col-xs-push-0 col-sm-push-0 col-md-push-0 col-lg-push-0">
                          <label>
                            <small style="color: black;">Importo in cifre</small>
                          </label>
                          <div class="form-group input-group-sm">
                            <span id="labelEuro" style="color: black;">Euro</span>

                            <currency-input
                                style="width:65%"
                                :precision="currency_config.precision"
                                :distraction-free="distractionFree"
                                class="currency-field"
                                v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                v-model="amortization.single_rate_amount"
                                currency="EUR"
                                @focusout="getLettersFromNumber()"
                                locale="it"/>


                          </div>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                          <p>Al</p>
                        </div>

                        <div class="col-xs-10 col-sm-4 col-md-4 col-lg-4">
                          <div class="form-group input-group-sm">
                            <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                   type="date" class="form-control input-size-xs"
                                   placeholder="Scadenza (gg/mm/anno)"
                                   v-model="amortization.date_end"
                            >
                          </div>
                        </div>

                        <div id="cambiale-pag"
                             class="col-xs-1 col-sm-1 col-md-1 col-lg-1 ">
                          <p>pag</p>
                        </div>

                        <div class="col-xs-5 col-sm-2 col-md-2 col-lg-2 ">
                          <div class="form-group input-group-sm">
                            <select class="form-control input-size-xs"
                                    v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                    v-model="amortization.type_promissory_note">
                              <option>herò</option>
                              <option>heremo</option>
                              <option>herete</option>
                              <option>herà</option>
                              <option>Nessuna Scritta</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3">
                          <p>per questa cambiale</p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                          <p>Al</p>
                        </div>

                        <div class="col-xs-7 col-sm-9 col-md-9 col-lg-9">
                          <div class="form-group input-group-sm">
                            <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                   type="text" class="form-control input-size-xs"
                                   v-model="amortization.beneficiary"
                                   placeholder="Beneficiario">
                          </div>
                        </div>

                        <div class="col-xs-4 col-sm-9 col-md-2 col-lg-2">
                          <p>la somma </p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-xs-12 col-sm-1 col-md-1 col-lg-1"
                             style="padding-right:0px;">
                          <p>di Euro </p>
                        </div>

                        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">


                          <div class="input-group ">
                            <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                   type="text" class="form-control input-size-xs"
                                   placeholder="Importo in lettere"
                                   v-model="amortization.total_in_letters"
                            >
                            <div class="input-group-append">
                              <button class="btn btn-primary no-padding" @click="convertLettersAmount">
                                <span v-if="this.isUppercaseMode">Aa</span>
                                <span v-else>aA</span>
                              </button>
                              <button class="btn btn-outline-secondary no-padding" @click="toggleHashtag">
                                #
                              </button>
                            </div>

                          </div>


                        </div>


                      </div>

                    </div>

                  </div>


                  <div class="row">

                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div id="domiciliazione">
                        <label>
                          <small>DOMICILIAZIONE</small>
                        </label>

                        <div class=" input-group-sm">
                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 type="text" class="form-control"
                                 placeholder="Nome" v-model="amortization.pay_name">


                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 type="text" class="form-control"
                                 placeholder="Indirizzo"
                                 v-model="amortization.pay_address"
                          >

                          <div class="row">
                            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       v-model="amortization.pay_zip_code"
                                       class="form-control" placeholder="Cap">
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       class="form-control" placeholder="Comune"
                                       v-model="amortization.pay_town"
                                >
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       class="form-control"
                                       placeholder="Prov"
                                       v-model="amortization.pay_city"
                                >
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       class="form-control" placeholder="ABI"
                                       v-model="amortization.abl"
                                >
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       class="form-control" placeholder="CAB"
                                       v-model="amortization.cab"
                                >
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div id="debitore">
                        <label>
                          <small>DEBITORE</small>
                        </label>
                        <div class="input-group-sm">

                          <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text" class="form-control"
                                       v-model="amortization.debtor_last_name"

                                       placeholder="Cognome">
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text" class="form-control"
                                       v-model="amortization.debtor_first_name"
                                       placeholder="Nome">
                              </div>
                            </div>
                          </div>

                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 type="text" class="form-control"
                                 placeholder="CODICE FISCALE"
                                 v-model="amortization.debtor_fiscal_code"
                          >

                          <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 type="text" class="form-control"
                                 v-model="amortization.debtor_address"
                                 placeholder="Indirizzo">


                          <div class="row">
                            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text" class="form-control"
                                       v-model="amortization.debtor_zip_code"
                                       placeholder="Cap">
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text" class="form-control"
                                       v-model="amortization.debtor_town"
                                       placeholder="Località">
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                              <div class="input-group-sm">
                                <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                       type="text"
                                       v-model="amortization.debtor_city"
                                       class="form-control"
                                       placeholder="Prov">
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="col col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div id="firma">
                        <label>
                          <small>FIRMA</small>
                        </label>

                        <div class="input-group-sm">
                          <input id="cambiale_firma-nome" type="text"
                                 class="form-control"
                                 v-model="amortization.signature_text"
                                 v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 placeholder="Testo Firma 1">

                          <input id="cambiale_firma-cognome" type="text"
                                 class="form-control"
                                 v-model="amortization.signature_text2"
                                 v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 placeholder="Testo Firma 2">

                          <input id="cambiale_firma-codiceFiscale" type="text"
                                 class="form-control"
                                 v-model="amortization.signature_text3"
                                 v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 placeholder="Testo Firma 3">

                          <input type="text"
                                 class="form-control"
                                 v-model="amortization.signature_text4"
                                 v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                 placeholder="Testo Firma 4">

                        </div>

                        <p style="position: relative;
margin-right: 10px;
width: 60px;
margin-top: -22px;
float: right;">
                          <small>(firma)</small>
                        </p>
                      </div>

                    </div>


                  </div>


                </div>

                <div class="row">
                  <div class="col col-12 col-xs-12 col-sm-12 col-md-6">
                    <div class="input-group-sm">
                      <input type="text"
                             class="form-control" placeholder="Avallante 1 o altre note"
                             v-model="amortization.avallante1"
                      >
                    </div>

                  </div>


                  <div class="col col-12 col-xs-12 col-sm-12 col-md-6">
                    <div class="input-group-sm ">
                      <input type="text"
                             class="form-control" placeholder="Avallante 2 o altre note"
                             v-model="amortization.avallante2"
                      >
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>


    </div>


    <div class="container ed-bg text-color"  style="margin: 0px 6px 0px 10px; ">
      <div class="row">
        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3   col-xs-push-0 col-sm-push-0 col-md-push-0 col-lg-push-0 "
        >
          <div class="subLayout-1row-1column">
            <div class="module" id="CambialiGenera">


              <!-- {#                               GENERA CAMBIALI Title + ToolBar                           #} -->
              <!-- {# *************************************************************************************** #} -->
              <div class="module-title-toolbar">
                <div class="row">
                  <div
                      class="col-xs-12 col-sm-4 col-md-12 col-lg-12   col-xs-push-0 col-sm-push-0 col-md-push-0 col-lg-push-0 ">
                    <h4 class="pull-left">Genera Cambiali</h4>
                  </div>
                </div>
              </div>
              <!-- {# *********************************************************************************************** #} -->
              <!-- {# *********************************************************************************************** #} -->


              <!-- {#                               GENERA CAMBIALI - Content: Form Generate                  #} -->
              <!-- {# *************************************************************************************** #} -->
              <div class="module-content">

                <div class="row">
                  <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <div class="form-group input-group-sm">
                      <input id="generateCambiali_numberRate" type="number"
                             class="form-control"
                             placeholder="N.Rate"
                             max="600"
                             v-model="amortization.rates"
                             v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'">
                    </div>
                  </div>
                  <!-- <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                      <div class="form-group input-group-sm">
                          <p> N. Rate (Cambiali)</p>
                      </div>
                  </div> -->

                  <!--
                                    <div class="col-xs-5 col-sm-7 col-md-7 col-lg-7">
                                      <div class="form-group input-group-sm">
                                        <select v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                                                class="form-control" style="font-size: 12px;"
                                                v-model="amortization.calculation_type"
                                                @change="showTotalBox">
                                          <option value="FISSO">Imp. singola</option>
                                          <option value="CALCOLATO">
                                            Tot imp/rate
                                          </option>
                                        </select>
                                      </div>
                                  </div>-->
                  <input type="hidden" v-model="amortization.calculation_type" value="FISSO">

                  <!-- <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 ">
                      <div class="form-group input-group-sm">
                          <p>Tipo Importo</p>
                      </div>
                  </div> -->

                </div>


                <div class="row">
                  <!-- <div class="col-xs-12 col-sm-4 col-md-7 col-lg-7">
                      <div class="form-group input-group-sm">
                          <select class="form-control"
                                  v-model="amortization.calculation_type"
                                  @change="showTotalBox">
                              <option value="CALCOLATO">Tot imp./rate</option>
                              <option value="FISSO">Importo fisso</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5 ">
                      <div class="form-group input-group-sm">
                          <p>Tipo Importo</p>
                      </div>
                  </div> -->
                </div>


                <div class="row" v-if="showImportoSingolaRata">
                  <div class="col-xs-12 col-sm-4 col-md-7 col-lg-7">
                    <div class="form-group input-group-sm">
                      <!--<input id="prestito_singola_rata" class="form-control"
                             placeholder="Importo singola rata"
                             type="number"  step="2"
                             v-model="amortization.single_rate_amount"
                             v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'">-->

                      <currency-input
                          class="currency-field"
                          :distraction-free="distractionFree"
                          v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                          v-model="amortization.single_rate_amount"
                          @focusout="getLettersFromNumber()"

                          currency="EUR"
                          locale="it"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5 ">
                    <div class="form-group input-group-sm">
                      <p>Imp. S. rata</p>
                    </div>
                  </div>
                </div>


                <div class="row" v-if="!showImportoSingolaRata ">
                  <div class="col-xs-12 col-sm-4 col-md-7 col-lg-7">
                    <div class="form-group input-group-sm">
                      <currency-input
                          :precision="currency_config.precision"
                          :distraction-free="distractionFree"
                          class="currency-field"
                          v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                          v-model="amortization.total_amount"
                          @focusout="getLettersFromNumber()"
                          currency="EUR"
                          locale="it"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5 ">
                    <div class="form-group input-group-sm">
                      <p>Tot. Importo </p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-12 col-sm-4 col-md-7 col-lg-7">
                    <div class="form-group input-group-sm">
                      <input v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                             type="date" class="form-control"
                             placeholder="Scadenza 1 Rata"
                             v-model="amortization.date_end">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5">
                    <div class="form-group input-group-sm">
                      <p id="dataScadenza">Scad.1-Rata </p>
                    </div>
                  </div>
                </div>


                <!--  <div class="row">
                      <div class="col-xs-12 col-sm-4 col-md-7 col-lg-7">
                          <div class="form-group input-group-sm">
                              <input type="date" class="form-control" placeholder="Fine Rate"
                                     v-model="amortization.date_end">
                          </div>
                      </div>
                      <div class="col-xs-12 col-sm-8 col-md-5 col-lg-5">
                          <div class="form-group input-group-sm">
                              <p id="dataFine">Fine Rate</p>
                          </div>
                      </div>
                  </div>-->


                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                    <div class="form-group input-group-sm">
                      <select v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                              id="generateCambiali_select_scadenzaMese"
                              class="form-control"
                              v-model="amortization.schedule_monthly_payment">
                        <option value="MENSILE">Scadenze Mensili</option>
                        <option value="BIMESTRALE">Scadenze Bimestrali</option>
                        <option value="TRIMESTRALE">Scadenze Trimestrali</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                    <div class="form-group input-group-sm">
                      <select v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"
                              class="form-control"
                              v-model="amortization.schedule_day_payment">
                        <option value="END_MONTH">Fine del mese</option>
                        <option value="FIXED_DATE">Data Specifica</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button v-if="amortization.id && amortization.status!='CONFIRMED'"
                            id="generateCambiali_button"
                            type="button"
                            class="btn btn-primary btn-sm float-left"
                            style="background: rgb(51, 153, 153);
min-width: 150px;
border: none;
height: 34px;"
                            @click.prevent="publishMessage='Cambiali generate con successo.';updateAmortization()">
                      Genera Cambiali
                    </button>
                    <button v-if="amortization.id && amortization.status=='CONFIRMED'"
                            id="generateCambiali_button"
                            type="button"
                            class="btn btn-primary btn-sm float-left"
                            style="
min-width: 150px;
border: none;
height: 34px;background:grey;border:none;"
                            disabled
                    >
                      Modifiche Disabilitate
                    </button>

                    <!-- Rectangular switch -->
                    <label style="" class="switch float-right" v-if="amortization.id">

                      <input type="checkbox"
                             v-model="isModifyMode"
                             v-bind:checked="amortization.id && amortization.status!='CONFIRMED'"
                             v-on:change="updateStatusAmortization()">
                      <span class="slider"></span>
                    </label>


                    <button v-if="!amortization.id" id="generateCambiali_button"
                            type="button"
                            class="btn btn-primary btn-sm btn-group-justified"
                            @click.prevent="publishMessage='Cambiali generate con successo.';addAmortization()">
                      Genera Cambiali
                    </button>
                  </div>
                </div>
              </div>
              <!-- {# *********************************************************************************************** #} -->
              <!-- {# *********************************************************************************************** #} -->
            </div>

          </div>
        </div>

        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9   col-xs-push-0 col-sm-push-0 col-md-push-0 col-lg-push-0 "
        >
          <div class="subLayout-1row-2column">

            <div id="cambialiCurrentList" class="module">
              <!-- {#     MODULE: CambialeCURRENTLIST_TO-OPERATE (Ovvero cambiali momentanee su cui operare)    #} -->


              <!-- {#                               LISTA CAMBIALI ATTUALI -  Title + ToolBar                 #} -->
              <!-- {# *************************************************************************************** #} -->
              <div class="module-title-toolbar">

                <div class="row">
                  <div class="col-xs-12 col-sm-7 col-md-10 col-lg-10 text-left">

                    <h4 class="pull-left ">Cambiali

                      <small v-if="isLoadingPdf"
                             style="padding-top:2px;padding-bottom:2px; padding-left: 5%;font-size:14px">
                        Stima: 48 rate in circa 30 sec - 150 rate in circa 50 sec
                      </small>
                      <small v-if="!isLoadingPdf"
                             style="padding-top:2px;padding-bottom:2px; padding-left: 5%;">
                        PDF
                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link" style="margin-left:10px"
                           @click="showPdf(amortization.id,'top-left')"
                        >Alto-Sinistra</a>

                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link"
                           @click="showPdf(amortization.id,'top-right')">
                          Alto-Destra</a>
                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link"
                           @click="showPdf(amortization.id,'bottom-left')"
                        >Basso-Sinistra</a>

                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link"
                           @click="showPdf(amortization.id,'bottom-right')"
                        >Basso-Destra</a>

                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link"
                           @click="showPdf(amortization.id,'center-left')"
                        >Centro-Sinistra</a>
                        <a v-if="amortization.pdf_path" target="_blank"
                           class="btn btn-primary pdf-link"
                           @click="showPdf(amortization.id,'center-right')"
                        >
                          Centro-Destra</a>

                      </small>
                    </h4>


                  </div>

                  <div class="col-xs-12 col-sm-5 col-md-2 col-lg-2 text-right">
                    <ul class="nav navbar-nav pull-right" v-if="amortization.id">


                      <li>

                        <a @click.prevent="publishMessage='Pratica salvata con successo.';amortization.status='CONFIRMED';updateAmortization()"
                           title="Salva Pratica">
                          <i class="material-icons">save</i>
                        </a>
                        &nbsp;-&nbsp;
                        <a v-show="isLoadingPdf">
                          <div class="spinner-border"
                               style="width:1.5rem;height:1.5rem;float:right;margin-top:3px;"></div>

                        </a>

                        <a v-show="!isLoadingPdf" @click="generatePdf()"
                           title="Stampa tutta le cambiali mostrate nella tabella sottostante">
                          <i class="material-icons">local_printshop</i>

                        </a>


                        <!-- <img   v-show="!isLoadingPdf "@click="generatePdf()"
                            alt="Stampa tutta le cambiali mostrate nella tabella sottostante"
                            src="../assets/printer.png" height="20" width="20"> -->
                      </li>

                    </ul>
                  </div>
                </div>

              </div>
              <!-- {# *************************************************************************************** #} -->


              <!-- {#                      CONTENUTO    LISTA CAMBIALI ATTUALI                                #} -->
              <!-- {# *************************************************************************************** #} -->
              <div class="module-content">  <!--  -->

                <div class="row">
                  <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">


                    <!-- <div class="table-responsive table-cf">
                        <table class="table table-sm table-striped table-bordered table-light">
                          <thead>

                            <tr>
                              <th scope="col">N.</th>
                              <th scope="col">Scadenza</th>
                              <th scope="col">Importo</th>
                              <th scope="col" style="min-width:140px;">Importo In Lettere</th>
                              <th scope="col">Operazione</th>

                            </tr>
                          </thead>
                          <tbody>
                                <tr v-for="(rate, index) in amortizationRates">
                                    <th scope="row">{{rate.number}}</th>
                                    <td><input type="date"   :value="rate.date" class="form-control input-xs"/></td>
                                    <td><input type="number" :value="rate.amount" class="form-control input-xs"/></td>
                                    <td><input type="text"   :value="rate.amount_string" class="form-control input-xs"/></td>
                                    <td>Cancella</td>
                                </tr>

                          </tbody>
                        </table>
                    </div>       -->


                    <div class="table-responsive table-cf">
                      <table class="table  table-sm   table-striped "
                             v-if="amortizationRates.length > 0">
                        <!-- table-bordered table-condensed cf-table-main -->
                        <!-- <table class="table table-sm table-striped table-bordered table-light">        -->

                        <thead id="cambiale-rows">
                        <tr>
                          <th class="cell-cambiale-number "> N.</th>
                          <th style="width:100px !important; max-width: 100px !important;"
                              class="cell-cambiale-data text-left">
                            Scadenza
                          </th>
                          <th class="cell-cambiale-importoCifre text-left">
                            Importo
                          </th>
                          <th class="cell-cambiale-importoLettere text-left">
                            Importo in
                            Lettere
                          </th>
                          <!--  <th class="cell-cambiale-importoCifreTot text-left">
                                Operazioni
                            </th>-->
                        </tr>
                        </thead>
                        <tbody>
                        <!-- style=" min-width: 100px !important; max-width: 120px !important;" -->
                        <tr v-for="(rate, index) in amortizationRates">
                          <td>{{ rate.number }}</td>
                          <td><input
                              disabled
                              type="date" :value="rate.date"
                              class="form-control  input-xs"/></td>
                          <td>
                            <currency-input
                                :precision="currency_config.precision"
                                :distraction-free="distractionFree"
                                v-model="rate.amount"
                                currency="EUR"
                                locale="it" disabled/>

                          </td>
                          <td style=" min-width: 300px !important;"><input
                              type="text" :value="rate.amount_string"
                              class="form-control  input-xs"/>
                          </td>
                          <!--  v-bind:disabled="amortization.id && amortization.status=='CONFIRMED'"-->
                          <!--  <td> Delete - edit - duplica - salva</td> -->
                        </tr>
                        </tbody>

                      </table>
                    </div>

                  </div>
                </div>

              </div>
              <div id="table-risultato"
                   class="table-responsive table-risultato cf-table-total">
                <table class="table  table-sm table-bordered table-condensed table-striped table-risultato">
                  <tbody>
                  <tr>
                    <!-- Lascio qui lo stile sulla larghezza delle celle, perchè è piu semplice allineare tali celle alle celle della tabella sofrastante.   -->
                    <td class="cell-cambiale-number">
                      <span>{{ amortizationRates.length }}</span></td>

                    <td class="cell-cambiale-data">
                      <span
                          v-if="amortizationRates.length>0">{{
                          $moment(amortizationRates[0].date).format('D-M-Y')
                        }}</span>
                    </td>

                    <td class="cell-cambiale-data">
                      <span
                          v-if="amortizationRates.length>0">{{
                          $moment(amortizationRates[amortizationRates.length - 1].date).format('D-M-Y')
                        }}</span>
                    </td>

                    <!-- <td class="cell-cambiale-importoCifre cf-warning"> <span><%- totImporto %></span> </td> -->

                    <td class="cell-cambiale-importoCifre" style="text-align:right">
                      <span v-if="amortization.total_amount">{{ amortization.total_amount | formatNumber }} €</span>
                    </td>
                    <td class="cell-cambiale-importoLettere"></td>
                    <td class="cell-cambiale-importoCifreTot"> Totali</td>
                  </tr>

                  </tbody>
                </table>

                <!-- <div v-if="!isLoadingPdf" style="padding-top:2px;padding-bottom:2px;">
                    <a v-if="amortization.pdf_path" target="_blank"
                       :href="basePathApi+'/'+amortization.pdf_path+'_hor.pdf'">PDF
                        Orizzontale</a> -
                    <a v-if="amortization.pdf_path" target="_blank"
                       :href="basePathApi+'/'+amortization.pdf_path+'_vert.pdf'">PDF
                        Verticale</a>
                </div> -->
              </div>

            </div>


          </div>
        </div>
      </div>

    </div>


  </layout-with-sidebar>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import LayoutWithSidebar from '@/components/layouts/LayoutWithSidebar'

import HeaderComponent from '../../components/HeaderComponent.vue'
import download from 'downloadjs'

export default {
  name: 'ModifyAmortization',
  components: {
    LayoutWithSidebar,
    HeaderComponent
  },
  data: function () {
    return {
      //vue currency plugin config
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' #',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      hideNegligibleDecimalDigits: false,
      hideCurrencySymbol: false,
      hideGroupingSymbol: false,
      // end vue currency plugin config
      isModifyMode: true,
      showImportoSingolaRata: true,
      isUppercaseMode: true,
      amortization: {
        calculation_type: 'FISSO',
        schedule_monthly_payment: 'MENSILE',
        schedule_day_payment: 'END_MONTH',
        type_promissory_note: 'herò',
        practice_date: (new Date()).getFullYear() + '-' + ("0" + ((new Date()).getMonth() + 1)).slice(-2) + '-' + ("0" + ((new Date()).getDate())).slice(-2),
        date_issue: (new Date()).getFullYear() + '-' + ("0" + ((new Date()).getMonth() + 1)).slice(-2) + '-' + ("0" + ((new Date()).getDate())).slice(-2),
        total_in_letters: ''
      },
      publishMessage: 'Rate generate con successo',
      totalRates: 0,
      isLoadingPdf: false,
      errors: [],
      basePathApi: process.env.VUE_APP_API_BASE_URL,
      amortizationRates: []
    }
  },
  mounted: function () {
    this.getAmortization()
  },
  computed: {
    distractionFree() {
      return {
        hideNegligibleDecimalDigits: this.hideNegligibleDecimalDigits,
        hideCurrencySymbol: this.hideCurrencySymbol,
        hideGroupingSymbol: this.hideGroupingSymbol
      }
    }
  },
  methods: {
    convertLettersAmount: function () {
      this.isUppercaseMode = !this.isUppercaseMode

      if (this.isUppercaseMode) {
        this.amortization.total_in_letters = this.amortization.total_in_letters.toUpperCase()
      } else {
        this.amortization.total_in_letters = this.amortization.total_in_letters.toLowerCase()
      }
    },
    getAmortization: function () {
      var $vm = this

      if ($vm.$route.params.id !== 'create') {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + $vm.$route.params.id)
            .then(function (response) {
              $vm.amortization = response.data

              if ($vm.amortization.id && $vm.amortization.status == 'CONFIRMED') {
                $vm.isModifyMode = false
              }

              $vm.amortizationRates = response.data.amortization_rates
              let total = 0
              for (let i = 0; i < $vm.amortizationRates.length; i++) {
                total += parseInt($vm.amortizationRates[i].amount)
              }
              $vm.totalRates = total

              $vm.showTotalBox()
            })
      }

    },
    generatePdf: function () {
      var $vm = this

      $vm.isLoadingPdf = true
      axios({
        url: process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + $vm.$route.params.id + '/pdf',
        method: 'POST',
        responseType: 'json', // important
      }).then((response) => {
        $vm.isLoadingPdf = false
        $vm.getAmortization()

      })
    },
    showTotalBox: function () {
      if (this.amortization.calculation_type === 'FISSO') {
        this.showImportoSingolaRata = true
      } else {
        this.showImportoSingolaRata = false

      }
    },
    addAmortization: function () {
      var $vm = this

      var amortizationJson = JSON.parse(JSON.stringify($vm.amortization))
      amortizationJson.date_start = $vm.$moment(amortizationJson.date_start).format('Y-M-D')
      amortizationJson.date_end = $vm.$moment(amortizationJson.date_end).format('Y-M-D')
      if (amortizationJson.practice_date == '') {
        amortizationJson.practice_date = null
      }
      amortizationJson.user = {
        id: $vm.loggedUser.id
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization',
          amortizationJson
      ).then(function (response) {
        $vm.$dialog.alert($vm.publishMessage, {html: true, okText: 'Continua'}).then(function (dialog) {
          $vm.$router.push({name: 'modify_amortization', params: {id: response.data.id}})
        })

      }).catch(function (e) {

        if (e.response.status === 400) {
          $vm.$dialog.alert(e.response.data.html, {
            html: true,
            okText: 'Continua'
          }).then(function (dialog) {

          })
        } else {
          $vm.$dialog.alert('Internal Server Error.', {
            html: true,
            okText: 'Continua'
          }).then(function (dialog) {

          })
        }

      })

    },
    getLettersFromNumber: function (callback = null) {
      let vm = this

      let rateAmount = 0

      if (this.showImportoSingolaRata) {
        rateAmount = this.amortization.single_rate_amount
      } else {
        rateAmount = parseFloat(this.amortization.total_amount / this.amortization.rates).toFixed(2)
        this.amortization.single_rate_amount = rateAmount
      }

      axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/get-number-letters?number=' + rateAmount).then(function (response) {
        let amountInLetters = response.data.letters
        vm.amortization.total_in_letters = '#' + amountInLetters.toUpperCase() + '/' + response.data.numbers + '#'
        if (callback) {
          callback()
        }
      })
    },
    showPdf: function (id, type) {
      var vm = this
      axios({
        url: process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + id + '/pdf?type=' + type,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
            [response.data],
            {type: 'application/pdf'})//Build a URL from the file
        const fileURL = URL.createObjectURL(file)//Open the URL on new Window

        const content = response.headers['content-type'];
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        download(response.data, date + ' Pratica Cambiale #' + vm.amortization.code + '.pdf', content)


      })

    }
    ,
    updateAmortization: function () {
      var $vm = this


      var amortizationJson = JSON.parse(JSON.stringify($vm.amortization))
      amortizationJson.date_start = $vm.$moment(amortizationJson.date_start).format('Y-M-D')
      amortizationJson.date_end = $vm.$moment(amortizationJson.date_end).format('Y-M-D')

      delete amortizationJson.amortization_rates

      console.log(amortizationJson)
      axios.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + $vm.amortization.id,
          amortizationJson
      ).then(function (response) {

        axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/' + $vm.amortization.id)
            .then(function (response) {
              $vm.amortization = response.data

              if ($vm.amortization.id && $vm.amortization.status == 'CONFIRMED') {
                $vm.isModifyMode = false
              }

              $vm.amortizationRates = response.data.amortization_rates

              $vm.$toasted.show($vm.publishMessage, {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 1300,
                type: 'success',
                class: 'toast'
              })


            })

      }).catch(function (e) {

        if (e.response.status === 400) {
          $vm.$dialog.alert(e.response.data.html, {
            html: true,
            okText: 'Continua'
          }).then(function (dialog) {

          })
        } else {
          $vm.$dialog.alert('Internal Server Error.', {
            html: true,
            okText: 'Continua'
          }).then(function (dialog) {

          })
        }

      })

    }
    ,
    saveSingleRate: function (rate) {
      var $vm = this
      var params = JSON.parse(JSON.stringify(rate))
      params.amortization = {
        id: $vm.amortization.id
      }
      axios.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization-rate/' + rate.id,
          params
      ).then(function (response) {

      })
    }
    ,
    updateStatusAmortization: function () {

      if (!this.isModifyMode) {
        this.amortization.status = 'CONFIRMED'
      } else {
        this.amortization.status = 'QUOTATION'
      }
    },
    toggleHashtag: function () {

      let hasHashtag = false
      if (this.amortization.total_in_letters.startsWith('#') || this.amortization.total_in_letters.endsWith('#')) {
        hasHashtag = true
      }

      if (!hasHashtag) {
        this.amortization.total_in_letters = '#' + this.amortization.total_in_letters + '#'
      } else {
        if (this.amortization.total_in_letters.startsWith('#')) {
          this.amortization.total_in_letters = this.amortization.total_in_letters.slice(1)
        }

        if (this.amortization.total_in_letters.endsWith('#')) {
          this.amortization.total_in_letters = this.amortization.total_in_letters.slice(0, -1)
        }
      }
    }
  }
}
</script>

<style scoped type="scss">

p {
  color: black;
}

/* grandezza imput boxs */
.input-size-xs {
  font-size: 12px !important;
}

.dg-btn--ok {
  color: white !important;
  background-color: darkgreen !important;
}

.cambialeFacile-Develop {
  font-size: 10px;
}

body {
  background-color: #0E74AF;
  font-family: Arial, Verdana, Helvetica, sans-serif !important;
}


/* *******************************  Page HEADER  ***************************** */
#headerPage {
  margin-bottom: 20px;
}

.navbar {
  height: 20px;
  min-height: 40px;
  max-height: 70px;
  margin: 0px;
  border-radius: 0px;
}

.navbar-nav {
  margin-top: 3px;
  margin-right: 5px;
}

.navbar-nav > li > a {
  padding-bottom: 5px;
  padding-top: 5px;
}

.navbar-brand {
  height: 30px;
  padding: 15px 15px;
  font-size: 18px;
  line-height: 20px;
}

#logoCambialeFacile {
  margin: 0px;
  padding: 0px;
}

#logoCambialeFacile p {
  float: left;
  margin-top: 6px;
  margin-left: 6px;
  font-weight: bold;
  font-size: 22px;
}

#logoCambialeFacile img {
  float: left;
  margin-top: 4px;
}


.container-fluid { /*Forse da eliminare; modifica lo stile di impercettibili cambiamenti visivi*/
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  padding: 0px;
}


/* *******************************  CONTAINER   ***************************** */
/* Distanza tra: container del header-Page  ed  container di sotto (pubblicità + Cambiale ) */
.container { /*margin-bottom: 20px;*/
  border: 0px solid red;
}


/* *******************************  GENERICO - BLOCCO MODULE  ***************************** */
.module {
  background-color: white;
  margin-bottom: 20px;
}

.module label {
  margin-bottom: 0px;
}

.module-title-toolbar {
  background-color: #E3E3E3;
  padding: 0px 4px 0px 10px;
}

.module-title-toolbar h4 {
  padding: 6px 0px;
  font-size: 16px;
  color: #4D4D4D;
}

.module-title-toolbar h4 {
  margin: 0px;
  margin-bottom: 0px;
  font-weight: bold;
}

.module-title-toolbar ul {
  margin: 0px;
  margin-bottom: 0px;
}

.module-title-toolbar ul > li > a {
  padding-bottom: 4px;
  padding-top: 6px;
}

.glyphicon {
  color: #333333;
  font-size: 16px;
}

.module-content {
  padding: 0px;
}

.form-group {
  margin-bottom: 4px;
}


/* *******************************  CAMBIALE - MODULE  ***************************** */
#cambiale .module-content {
  padding: 0px 10px 0px 10px
}

#cambiale p {
  font-size: 12px;
}

#labelEuro {
  float: left;
  width: 40px
}

#cambiale_importoCifre {
  width: 130px;
  float: left;
}

#virgola {
  float: left;
  margin-top: 15px;
  margin-bottom: 0px;
  margin-right: 4px;
  margin-left: 4px;
}

#cambiale_importoCifreCentesimi {
  width: 35px;
  float: left; /* float:left;  margin-bottom: 0px; margin-right:0px; margin-left:0px; */
}

#cambiale-scadenza {
  width: 260px;
}

#cambiale-pag {
  padding-right: 2px;
  border: solid 0px;
  width: 40px;
}

#domiciliazione > .input-group-sm {
  border: solid 1px green;
}

#domiciliazione > label {
  color: green
}

#debitore > .input-group-sm {
  border: solid 1px red;
}

#debitore > label {
  color: red
}

#firma > .input-group-sm {
  border: solid 1px gray;
}

#firma > label {
  color: #8A8A8A;
}

#firma > p {
  text-align: right;
}

#cambiale-footer {
  border: solid 1px lightgray;
}

#cambiale-footer > p {
  color: lightgray;
}


/* *******************************  CAMBIALE GENERA - MODULE  ***************************** */
#CambialiGenera p {
  font-size: 11px;
}

#CambialiGenera .module-content {
  padding: 10px;
}


/* *******************************  CambialiCURRENT-LIST - MODULE  ***************************** */
#cambialiCurrentList .module-content {
  padding: 0px 0px 10px 0px;
}

#cambialiCurrentList .module-content {
  padding: 0px 0px 0px 0px;
}


#cambialiCurrentList .table-cf {
  height: 199px;
  border: solid 0px;
  border-bottom: 1px solid lightgray;
}

#cambialiCurrentList td {
  font-size: 12px;
}

#cambialiCurrentList th {
  font-size: 13px;
  text-align: center;
}

/*Solo perchè */
#cambialiCurrentList {
  margin-bottom: 0px;
  border-bottom: 0px;
}

#table-risultato {
  border-top: 0px;
}

/* *******************************  CambialiCURRENT-LIST - width fixed for the cell about Table ***************************** */
.cell-cambiale-number {
  width: 20px;
  max-width: 20px;
}

.cell-cambiale-data {
  width: 30px;
  max-width: 30px;
}

.cell-cambiale-importoCifre {
  width: 40px;
  max-width: 40px;
}

.cell-cambiale-importoLettere {
  width: 160px;
  max-width: 160px;
}

.cell-cambiale-importoCifreTot {
  width: 40px;
  max-width: 40px;
}

/* *******************************  Qualunque Tabella conicone   ***************************** */
table .glyphicon {
  color: #333333;
  font-size: 12px;
}


.table-risultato {
  border: solid 0px; /*margin-top: 200px;*/
  /* height: 50px*/
  margin: 0px;
}

.table-risultato table th {
  font-size: 8px;
}

#table-risultato th {
  font-size: 10px;
}

#table-risultato td {
  font-size: 10px;
}


.cf-warning {
  color: crimson;
  font-weight: bold;
}

/* *******************************  Modal Windows   ***************************** */
#CambialeSave .form label {
  font-size: 12px;
}


/* *******************************  Page-FOOTER  ***************************** */
.pageLayout-Footer > div {
  border: 1px solid #B8B8B8;
  background-color: #B8B8B8;
  background-color: #DFDFDF;
  padding: 10px;
}

.pageLayout-Footer > div > p {
  font-size: 11px;
  color: #666;
  margin: 0px;
  text-align: center;
}

.pageLayout-Footer > div > p a {
  color: #0077B5
}

/*Input super small */
.input-xs {
  height: 22px !important;
  padding: 2px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.input-group-xs > .form-control,
.input-group-xs > .input-group-addon,
.input-group-xs > .input-group-btn > .btn {
  height: 22px;
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dg-main-content {
  max-width: 440px !important;
}

.table-cf input.form-control {
  border-radius: 0px;
  height: 29px !important;
  font-size: 14px;
}

.table-cf input {
  color: rgb(33, 37, 41) !important;
}

.currency-field {
  width: 100%;
  color: rgb(73, 80, 87);
  font-size: 14px;
}

.btn-primary.pdf-link {
  font-size: 10px;
  padding: 3px;
  color: white !important;
  cursor: pointer;
  margin-right: 5px;
}


a {
  cursor: pointer !important;
}

a:hover {
  opacity: .8 !important;
}

.no-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}

#CambialiGenera {
  min-height: 260px;
}

</style>
